import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de.json";
import en from "./locales/en.json";
import { dropLegacyLanguage, readLanguageOverride } from "./utilities/language";

dropLegacyLanguage();

i18n.use(initReactI18next).init({
  // What the language starts as, not what it stays: the user's own setting is read off their
  // Geotab account, which is only known once the session has been read, and `useUserLanguage`
  // applies it as soon as it arrives. A language picked in the header overrides both for as long
  // as the tab is open.
  lng: readLanguageOverride() ?? "de",
  debug: import.meta.env.DEV,
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
